import { InfoOutlineIcon } from '@chakra-ui/icons';
import { HStack, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

import { url as commonUrl } from '@finley-technologies/common';

/**
 * No effect label for funding request mechanics properties that have not yet been hooked up. Conditionally
 * rendered only on Admin Dashboard
 *
 * See: FUNDING_REQUEST_PROPERTIES_WITH_NO_EFFECT
 */
export const NoEffectTooltip = () => {
  const isFinleyAdminDomain =
    window.location.host === commonUrl.getAdminDashboardHostname();
  if (!isFinleyAdminDomain) return null;
  return (
    <HStack>
      <Tooltip
        label="configuring this property does not affect product behavior; contact engineering to make the necessary backend config changes"
        hasArrow
      >
        <InfoOutlineIcon />
      </Tooltip>
      <Text>NO EFFECT</Text>
    </HStack>
  );
};
